/**
 * Comments v3 (spec 2026-10-18-comments-design, plan 1): rows from page_comments become threads per language; the
 * canvas gets the open threads that have a place. Main language = language_id null.
 */

const byTime = (a, b) => String(a.created_at).localeCompare(String(b.created_at));

/** Top-level comments of one language with their replies, oldest first. */
export function toThreads(rows, languageId) {
  const lang = languageId == null ? null : languageId;
  const replies = {};
  (rows || []).forEach((r) => {
    if (r.parent_id != null) (replies[r.parent_id] = replies[r.parent_id] || []).push(r);
  });
  return (rows || [])
    .filter((r) => r.parent_id == null && (r.language_id == null ? null : r.language_id) === lang)
    .sort(byTime)
    .map((r, i) => ({
      // The number the pin in the preview and the list show (plan 3b): order of writing, resolved ones keep theirs.
      number: i + 1,
      id: r.comment_id,
      comment: r,
      replies: (replies[r.comment_id] || []).slice().sort(byTime),
      resolved: !!r.resolution,
      anchor: r.anchor || null,
      languageId: lang,
    }));
}

/** Plan 3c: Erledigt (a resolution) wins; without a state row a thread is active. */
export function statusOf(thread) {
  if (thread.resolved) return 'resolved';
  const state = thread.comment && thread.comment.state;
  return (state && state.status) || 'active';
}

export function openCount(threads) {
  return threads.filter((t) => !t.resolved).length;
}

export function canResolve({ isSysAdmin, privileges }) {
  return !!isSysAdmin || (privileges || []).includes('can_edit_page');
}

/** Where a thread sits: the whole page, a Snippet still on the page, or one that is gone. */
export function placeLabel(thread, sectionIds) {
  if (!thread.anchor) return 'page';
  if (sectionIds && !sectionIds.has(thread.anchor.sectionId)) return 'gone';
  return 'element';
}

/** The language_id for comments in the shown language; null in the main language. */
export function languageIdFor(setup, picked) {
  if (!setup || !picked || picked === setup.main) return null;
  return setup.languageIds[picked] || null;
}

/** A change request needs a text place with its address inside the Bereich and the quoted words (plan 3). */
export function canSuggest(anchor) {
  return !!(anchor && anchor.address && anchor.quote);
}

/** The language handle of a comment's language_id; null for the main language. */
export function languageHandleFor(setup, languageId) {
  if (!setup || languageId == null) return null;
  return Object.keys(setup.languageIds).find((h) => h !== setup.main && setup.languageIds[h] === languageId) || null;
}

/** Open change requests of the threads, as the canvas checks and applies them. */
export function suggestionItems(threads, handleOf) {
  return threads
    .filter((t) => !t.resolved && t.comment.suggestion && canSuggest(t.anchor))
    .map((t) => ({
      id: t.id, sectionId: t.anchor.sectionId, address: t.anchor.address, quote: t.anchor.quote, language: handleOf(t.languageId),
    }));
}
